'use client'

import { useTranslate } from '@marketplace-web/shared/i18n'

const AccessibilityThirdSection = () => {
  const translate = useTranslate('accessibility.third-section')

  return (
    <section className="accessibility-landingpage__third-section">
      <h2 className="accessibility-landingpage__third-section-title">{translate('title')}</h2>
      <div className="accessibility-landingpage__third-section-description">
        <p
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: translate('description-1') }}
        />
        <p>{translate('description-2')}</p>
      </div>
    </section>
  )
}

export default AccessibilityThirdSection
